
<modal
  title="Settings"
  :open="open"
  @close="closeModal"
>
  <form @submit.stop.prevent="submit">
    <align small-gap>
      <text-input
        v-model.trim="name"
        label="Collection Name"
        maxlength="50"
      />

      <btn
        type="submit"
        class="submit-button"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Submitting"
      >
        Save
      </btn>
    </align>
  </form>

  <div class="button-row">
    <btn
      kind="secondary"
      @click="exportCollection"
    >
      Export CSV
    </btn>

    <btn
      v-if="allowDelete"
      kind="error"
      class="delete-button"
      :disabled="deleting"
      @click="deleteCollection"
    >
      Delete Collection
    </btn>
  </div>
</modal>
